import Vue from 'vue';
import Router from 'vue-router';

import NavBar from 'components/common/NavBar';
import FooterBar from 'components/common/FooterBar';

import Brochure from 'components/brochure/Brochure';
import Academic from 'components/brochure/Academic';
import Patient from 'components/brochure/Patient';
import Practice from 'components/brochure/Practice';
import About from 'components/brochure/About';
import Packages from 'components/brochure/Packages';
import MedEMass from 'components/brochure/MedEMass';
import PricePlans from 'components/brochure/PricePlans';

import User from 'components/user/User';
import Login from 'components/user/Login';
import SignUp from 'components/user/SignUp';
import ForgotPassword from 'components/user/ForgotPassword';
import ForgotUsername from 'components/user/ForgotUsername';
import ResetPassword from 'components/user/ResetPassword';
import VerifyEmail from 'components/user/VerifyEmail';
import RequestRemoval from 'components/user/RequestRemoval';

import VueAnalytics from 'vue-analytics';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Brochure',
      components: {
        default: Brochure,
        header: NavBar,
        footer: FooterBar,
      },
      children: [
        {
          path: '',
          component: Patient,
        },
        {
          path: 'academic',
          name: 'Academic',
          component: Academic,
        },
        {
          path: 'patient',
          name: 'Patient',
          component: Patient,
        },
        {
          path: 'practice',
          alias: 'providers',
          name: 'Practice',
          component: Practice,
        },
        {
          path: 'about',
          name: 'About',
          component: About,
        },
        {
          path: 'packages',
          name: 'Packages',
          component: Packages,
        },
        {
          path: 'priceplans',
          name: 'priceplans',
          component: PricePlans,
        },
      ],
    },
    {
      path: '/med-e-mass',
      name: 'MedEMass',
      components: {
        default: MedEMass,
      },
    },
    {
      path: '/',
      name: 'User',
      components: {
        default: User,
        header: NavBar,
      },
      children: [
        {
          path: 'login/:loginContext?',
          name: 'Login',
          component: Login,
          props: true,
        },
        {
          path: 'signup/:signupContext?',
          alias: 'register/:signupContext?',
          name: 'SignUp',
          component: SignUp,
          props: true,
        },
        {
          path: 'forgotpassword',
          name: 'ForgotPassword',
          component: ForgotPassword,
        },
        {
          path: 'forgotusername',
          name: 'ForgotUsername',
          component: ForgotUsername,
        },
        {
          path: 'passwordreset/:context/:hash',
          name: 'ResetPassword',
          component: ResetPassword,
          props: true,
        },
        {
          path: 'verifyEmail',
          name: 'VerifyEmail',
          component: VerifyEmail,
        },
        {
          path: 'requestremoval/:token',
          name: 'RequestRemoval',
          component: RequestRemoval,
        },
      ],
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

Vue.use(VueAnalytics, {
  id: 'UA-68267982-3',
  router,
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js